export default "__VITE_ASSET__Cr_0H08T__"